<template>
    <div ref="dropdownRef" class="relative inline-block" style="user-select: none;">
        <!-- Klickyta som visar valt värde eller standardtext -->
        <div @mouseup="handleMouseUp" @mousedown="handleMouseDown" class="items-center h-11 px-4 border border-black cursor-pointer flex justify-between">
            <p class="small m-0">
            {{ selectedOption || 'Choose an option' }}
            </p>
            <UiOpen class="close w-3" :class="{'open': dropdownOpen}" :forceHover="dropdownOpen"/>
        </div>

        <!-- Dropdown-lista med egna boxar -->
        <transition name="grow-in">
        <ul 
        v-if="dropdownOpen" 
        class="absolute mt-1 w-full border border-black bg-white z-10 shadow-xl"
        >
        <li 
            v-for="value in option.values" 
            :key="value"
            class="p-3 m-0 small hover:bg-gravaalightwarmgray cursor-pointer flex"            
            @mouseup="select(value, $event)"
            
        >
            {{ value }}
            <UiCheck class="pl-2 w-7" :checked="isSelected(value)"/>
        </li>
        </ul>
        </transition>
    </div>
</template>
  
<script setup lang="ts">
  import { ref, defineAsyncComponent } from 'vue';
  import { onClickOutside, useEventListener } from '@vueuse/core';
  const UiOpen = defineAsyncComponent(() => import('@/components/ui/open.vue'));
  
  interface Option {
    values: string[];
  }
const props = defineProps<{
    option: Option,
    selectedOption: string
}>()

const emit = defineEmits<{
  (e: 'change', value: string): void
}>()
  
  const dropdownOpen = ref(false);
  const dropdownRef = ref<HTMLElement | null>(null);
  const mouseDown = ref(false);
  
  function handleMouseDown() {
    console.log('handleMouseDown');
    mouseDown.value = true;
    if(dropdownOpen.value) {
      closeDropdown();
      return;
    }
    openDropdown();
    
  }

  function handleMouseUp() {
    mouseDown.value = false;
    //closeDropdown();
  }
  
  
  function toggleDropdown() {
    if (mouseDown.value) {
      mouseDown.value = false;
      return;
    }
    dropdownOpen.value = !dropdownOpen.value;
  }

  function closeDropdown() {
    dropdownOpen.value = false;
  }

  function openDropdown() {
    dropdownOpen.value = true;
  }

  onClickOutside(dropdownRef, closeDropdown);
  

  function select(value: string, event: MouseEvent) {
    
    emit('change', value);
    setTimeout(() => {
      closeDropdown();
    }, 300);    
}
  
  function isSelected(value: string): boolean {
    return props.selectedOption === value;
  }
  
  
  </script>
  